import { render, staticRenderFns } from "./PendingBooking.vue?vue&type=template&id=6fcf7a4c"
import script from "./PendingBooking.vue?vue&type=script&lang=js"
export * from "./PendingBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports